import { render, staticRenderFns } from "./Guest.vue?vue&type=template&id=2b2aac78&scoped=true"
import script from "./Guest.vue?vue&type=script&lang=js"
export * from "./Guest.vue?vue&type=script&lang=js"
import style0 from "./Guest.vue?vue&type=style&index=0&id=2b2aac78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2aac78",
  null
  
)

export default component.exports